<script setup lang="ts">
import { t } from '@/i18n';

const { user, signOut } = useAuth();

function handleSignOut() {
  signOut();
  navigateTo('/login');
}
</script>

<template>
  <div v-if="user" class="w-full text-center">
    <h1 class="text-2xl md:text-3xl font-normal text-black/90 mb-4">
      {{ t('landingPages.auth.loggedIn.welcome') }}
    </h1>
    <p class="text-base text-black/60 mb-8">
      {{ t('landingPages.auth.loggedIn.currentlyLoggedIn') }}<br />
      <span class="font-medium text-black/90">{{ user.email }}</span>
    </p>

    <div class="flex flex-col gap-4">
      <NuxtLink
        to="/workspace/create"
        class="w-full px-4 py-2 text-base font-normal bg-black/5 text-black/90 rounded-lg transition-all duration-200 hover:bg-black/10 hover:text-black flex items-center justify-center"
      >
        {{ t('landingPages.auth.loggedIn.goToWorkspace') }}
      </NuxtLink>

      <button
        @click="handleSignOut"
        class="w-full px-4 py-2 text-base font-normal text-black/40 hover:text-black/60 transition-colors duration-200"
      >
        {{ t('landingPages.auth.loggedIn.signOut') }}
      </button>
    </div>
  </div>
</template>
